import { Text as RNText } from "react-native";
import { withTextProps } from "~/hoc/withTextProps";
import type { WithTextProps } from "~/hoc/withTextProps";
import type React from "react";
import type { TextProps as RNTextProps } from "react-native";

export const Text = withTextProps(RNText);
export type Text = React.ElementRef<typeof RNText>;
export type TextProps = Omit<RNTextProps, keyof WithTextProps> & WithTextProps;
